import { isLoggedIn as isLoggedInGetter, user as userGetter } from '@/store/modules/auth/getters';
import { useStore } from '@/utils/store';

// TODO: give specific type to user
type User = unknown;

export const useAuthGetters = () => {
	const { getter } = useStore();
	return { isLoggedIn: getter<boolean>(isLoggedInGetter), user: getter<User>(userGetter) };
};
